import axios, { AxiosHeaders, AxiosProgressEvent, AxiosRequestConfig, AxiosRequestHeaders, CancelToken, InternalAxiosRequestConfig } from "axios"

const baseEndpoint = process.env.REACT_APP_ENDPOINT_BASE_API;

const baseHeader = (): AxiosRequestHeaders => {
    const header: AxiosRequestHeaders = new AxiosHeaders();
    header.setContentType("application/json;charset=UTF-8");
    header.setAccept("application/json");
    return header;

}
const baseConfig = { baseURL: baseEndpoint, headers: baseHeader(), };

const instance = axios.create(baseConfig);

instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig<any>) => {
        const { headers } = config;

        if (!headers.has("Access-Control-Allow-Origin"))
            headers.set("Access-Control-Allow-Origin", `${process.env.REACT_APP_REDIRECT_URI!.endsWith("/") ? process.env.REACT_APP_REDIRECT_URI!.substring(0, (process.env.REACT_APP_REDIRECT_URI!.length - 1)) : process.env.REACT_APP_REDIRECT_URI!.trim()}`);

        // if (!headers.has("Access-Control-Allow-Headers"))
        //     headers.set("Access-Control-Allow-Headers", "Authorization");

        // if (!headers.has("Access-Control-Allow-Methods"))
        //     headers.set("Access-Control-Allow-Methods", "GET, POST, OPTIONS, PUT, PATCH, DELETE")

        return config;
    },
    (error) => {
        return Promise.reject(error);
    });

export function CreateCancellableConfig<TModel>(cancelToken?: CancelToken, formData: FormData | undefined = undefined): AxiosRequestConfig<TModel> {
    const header: AxiosRequestHeaders = baseHeader();
    const result: AxiosRequestConfig<TModel> = {
        headers: header,
        cancelToken,
        transformRequest: (formData != null ? () => formData : undefined),
    }

    return result
}

export function CreateAuthHeader<TModel>(type: "Authentication" | "Bearer", value: string, cancelToken?: CancelToken, formData: FormData | undefined = undefined): AxiosRequestConfig<TModel> {

    const base = CreateCancellableConfig<TModel>(cancelToken, formData),
        header = (base.headers || baseHeader()) as AxiosRequestHeaders;

    header.setAuthorization(`${type} ${value}`, true);

    const result: AxiosRequestConfig<TModel> = {
        ...base,
        headers: header,
    }

    return result;
}

export function CreateAuthHeaderWithoutFormData<TModel>(type: "Authentication" | "Bearer", value: string, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void, onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void, cancelToken?: CancelToken): AxiosRequestConfig<TModel> {
    const base = CreateAuthHeader<TModel>(type, value, cancelToken),
        header = (base.headers || baseHeader()) as AxiosRequestHeaders,
        result: AxiosRequestConfig<TModel> = {
            ...base,
            headers: header,
            onUploadProgress,
            onDownloadProgress,
        }

    return result;
}

export function CreateAuthWithFileHeader<TModel>(type: "Authentication" | "Bearer", value: string, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void, onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void, cancelToken?: CancelToken): AxiosRequestConfig<TModel> {
    const base = CreateAuthHeader<TModel>(type, value, cancelToken),
        header = (base.headers || baseHeader()) as AxiosRequestHeaders;

    header.setContentType("multipart/form-data;");

    const result: AxiosRequestConfig<TModel> = {
        ...base,
        headers: header,
        onUploadProgress,
        onDownloadProgress,
        maxBodyLength: Infinity,
        maxContentLength: Infinity,
        //transformRequest: (formData) => formData
        //transformRequest: () => formData //must pass formData by function param.
        // env:{
        //     FormData:formData //must pass formData by function param.
        // }
    }

    return result;
}

export const CreateAuthToDeleteHeader = <TModel>(type: "Authentication" | "Bearer", value: string, boddy: TModel, cancelToken?: CancelToken): AxiosRequestConfig<TModel> => {

    const base = CreateAuthHeader<TModel>(type, value, cancelToken),
        header = (base.headers || baseHeader()) as AxiosRequestHeaders,
        result: AxiosRequestConfig<TModel> = {
            ...base,
            headers: header,
            data: boddy
        };

    return result;
}

export default instance;
